/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  AudienceConditions,
  AudienceConditionsFromJSON,
  AudienceConditionsFromJSONTyped,
  AudienceConditionsToJSON,
  SubMetric,
  SubMetricFromJSON,
  SubMetricFromJSONTyped,
  SubMetricToJSON,
} from './';

/**
 * A JSONPatch document as defined by RFC 6902
 * @export
 * @interface PatchRequestBody
 */
export interface PatchRequestBody {
  /**
   * The operation to be performed
   * @type {string}
   * @memberof PatchRequestBody
   */
  op: PatchRequestBodyOpEnum;
  /**
   * A JSON-Pointer to the resource or the resource attribute
   * @type {string}
   * @memberof PatchRequestBody
   */
  path: string;
  /**
   * The value to be used within the operations.
   * @type {object | Array<string> | AudienceConditions | string | number | boolean | Array<SubMetric>}
   * @memberof PatchRequestBody
   */
  value?:
    | object
    | Array<string>
    | AudienceConditions
    | string
    | number
    | boolean
    | Array<SubMetric>;
  /**
   * A JSON Pointer to the resource attribute
   * @type {string}
   * @memberof PatchRequestBody
   */
  from?: string;
}

export function PatchRequestBodyFromJSON(json: any): PatchRequestBody {
  return PatchRequestBodyFromJSONTyped(json, false);
}

export function PatchRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    op: json['op'],
    path: json['path'],
    value: !exists(json, 'value') ? undefined : json['value'],
    from: !exists(json, 'from') ? undefined : json['from'],
  };
}

export function PatchRequestBodyToJSON(value?: PatchRequestBody | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    op: value.op,
    path: value.path,
    value: value.value,
    from: value.from,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum PatchRequestBodyOpEnum {
  Add = 'add',
  Remove = 'remove',
  Replace = 'replace',
  Move = 'move',
  Copy = 'copy',
  Test = 'test',
}
